import React from 'react'
import comma from "../../assets/images/comma.png"
import picture from "../../assets/images/Picture.png"

function Testimonials() {
  return (
    <div className="testimonials">
      <div className="section1">
        <div className="section1__body">
          <h1 className="section1__title">
            Happy Customers
                        </h1>
          <p className="section1__content">
            Feedback from these happy customers helps us in reaching the heights
                    </p>
        </div>
      </div>
      <div className="section2">
        <div className="section2__content">
          <img src={comma} className="comma" alt=""  />
          <div className="body__title">
            <img src={picture} className="picture" alt=""  />
            <span className="title">Godspower Uche</span>
            <br />
            <span className="subtitle">Backend Developer</span>
          </div>
          <p className="text">We had an incredible experience working with Healthify and were impressed they made such
          a big difference in only three weeks. Our team is so grateful for the wonderful improvements
          they made and their ability to get familiar with the product concept so quickly.
          It acted as a catalyst to take our
          design to the next level and get more eyes on our product.
                    </p>
        </div>
      </div>
    </div>
  )
}

export default Testimonials